/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import TopicForm from "./TopicForm";
import Page from "../../shared/Page";

class TopicFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Topic";
		this.id = props.match.params.id ? props.match.params.id : 0;
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<TopicForm
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
				/>
			</div>
		);
	};

	renderCopyForm = () => {
		let item = undefined;
		if (this.props.items) {
			item = this.props.items.find(item => {
				return item.id === this.id;
			});
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Copy {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<TopicForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, item.id)}
						initialValues={item}
						buttonLabel={`Create ${this.label}`}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		let item = undefined;
		if (this.props.items) {
			item = this.props.items.find(item => {
				return item.id === this.id;
			});
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Update {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<TopicForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, item.id)}
						initialValues={item}
						buttonLabel={`Update ${this.label}`}
						actionType="update"
						id={item.id}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	render() {
		let content = "Loading";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				break;
		}
		return <Page title="My Topics">{content}</Page>;
	}
}

TopicFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
};

export default withRouter(TopicFormWrapper);
